module.exports = "\r\n.Blue{\r\n    color:blue;    \r\n}\r\n\r\n.Green{\r\n    color:brown\r\n}\r\n\r\n.Red{\r\n    color:red;\r\n}\r\n\r\n.DGreen{\r\n    color: green\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/depart-enquiry/showcause-notice-acknowledgement-dgos-reply/show-cause-ack-grid/show-cause-ack-grid.component.css
// module id = ./src/app/hrms/depart-enquiry/showcause-notice-acknowledgement-dgos-reply/show-cause-ack-grid/show-cause-ack-grid.component.css
// module chunks = main